import GrainIcon from '@material-ui/icons/Grain';
import ReorderIcon from '@material-ui/icons/Reorder';
import BasicReadField from './BasicReadField';
import OntologyIcon from '../core/icons/Ontology';
import { withRouter } from 'react-router-dom';
import { APPLICATION_PATHS } from '../application-core/constants';
import SchemeChip from '../vocabulary/core/SchemeChip';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { default as React } from 'react';
import CancelButton from './CancelButton';
import { globalStyles as styles } from './style/gstheme';
import TitledPanel from './TitledPanel';
import ExternalTypeLink from '../vocabulary/taxonomies/ExternalTypeLink';
import { Typography } from '@material-ui/core';

const titleProps = ["title", "prefLabel", "literalForm", "title", "title", "title", "label", "label", "label", "label", "label"];

class InfoLinkDialog extends React.Component {

    state = {
        open: true
    };

    exitInfoDialog = () => {
        this.setState({ open: false });
        this.props.onClose();
    };

    render() {

        const { classes, linkList, defaultLang, graph, validType, data, onToggleView } = this.props;
        const { open } = this.state;

        let label = validType;
        switch (validType) {
            case "ConceptScheme":
                label = "Concept Scheme";
                break;
            case "OrderedCollection":
                label = "Ordered Collection";
                break;
            case "OwlClass":
                label = "Class";
                break;
            case "ObjectProperty":
                label = "Object Property";
                break;
            case "DatatypeProperty":
                label = "Datatype Property";
                break;
            case "AnnotationProperty":
                label = "Annotation Property";
                break;
            default: label = validType;
        }
        const typeList = ["ConceptScheme", "Concept", "Label", "Collection", "OrderedCollection", "Ontology", "OwlClass", "ObjectProperty", "DatatypeProperty", "AnnotationProperty"];
        const typeIndex = typeList.findIndex(typeItem => data.type.includes(typeItem));
        const titleProp = titleProps[typeIndex];

        const isDeleted = "pendingDeletion" in data;
        const displayLang = data[titleProp] && data[titleProp][defaultLang] ?
            defaultLang
            :
            data[titleProp] && data[titleProp]["und"] ?
                "und"
                :
                defaultLang;
        const title = data[titleProp] && data[titleProp][displayLang] ?
            Array.isArray(data[titleProp][displayLang]) ?
                data[titleProp][displayLang].join(" AND ")
                :
                data[titleProp][displayLang]
            :
            "";

        return (
            <React.Fragment>
                <Dialog
                    data-test="info-link-dialog"
                    maxWidth="md"
                    fullWidth
                    classes={{
                        paper: classes.paper,
                        paperWidthMd: classes.mediumDialog
                    }}
                    open={open}
                    onClose={this.exitInfoDialog}
                    aria-labelledby="info-link-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="info-link-dialog-title">Resource Detail</DialogTitle>
                    <DialogContent>
                        <TitledPanel dataTest="resource-type" title="Type">
                            <ExternalTypeLink
                                id={validType}
                                label={label}
                                graph={graph}
                                isReadOnly={true}
                            />
                        </TitledPanel>
                        <TitledPanel margin dataTest="resource-type" title="Title">
                            <BasicReadField dataTest="resource-title" text={title} lang={displayLang} fullWidth />
                            {isDeleted &&
                                <Typography data-test="link-is-deleted" variant="body2">This resource is pending deletion.</Typography>
                            }
                        </TitledPanel>
                        {linkList && linkList.length > 0 && !isDeleted &&
                            <TitledPanel dataTest="schemes" margin title="View In (Ctrl+Click to Open in New Tab)">
                                {linkList.map(linkIRI => {
                                    const projectIRI = "https://grafsync.graphifi.com/data" + this.props.graph.substring(this.props.graph.indexOf("/graph") + 6);
                                    let link = ["Collection", "OrderedCollection"].includes(validType) ?
                                        '/project/collection#project=' + projectIRI + "&collection=" + linkIRI
                                        :
                                        ["ConceptScheme", "Label", "Concept"].includes(validType) ?
                                            '/project/taxonomy#project=' + projectIRI + "&taxonomy=" + linkIRI
                                            :
                                            '/project/ontology#project=' + projectIRI + "&ontology=" + linkIRI;
                                    if (validType === "Concept") link += "&view=concept&concept=" + this.props.data.id;
                                    if (validType === "Label") link += "&view=label&label=" + this.props.data.id;
                                    if (validType === "OwlClass") link += "&view=class&class=" + this.props.data.id;
                                    if (validType === "ObjectProperty") link += "&view=objectProperty&objectProperty=" + this.props.data.id;
                                    if (validType === "DatatypeProperty") link += "&view=datatypeProperty&datatypeProperty=" + this.props.data.id;
                                    if (validType === "AnnotationProperty") link += "&view=annotationProperty&annotationProperty=" + this.props.data.id;
                                    return <SchemeChip
                                        key={linkIRI}
                                        id={linkIRI}
                                        exitOnNewTab={this.exitInfoDialog}
                                        onLink={() => {
                                            this.exitInfoDialog();
                                            if (onToggleView) onToggleView();
                                        }}
                                        viewLang={defaultLang}
                                        defaultLang={defaultLang}
                                        isReadOnly={true}
                                        graph={graph}
                                        link={["ConceptScheme", "Concept", "Label", "Collection", "OrderedCollection"].includes(validType) ?
                                            APPLICATION_PATHS.TAXONOMY_MANAGER + link
                                            :
                                            APPLICATION_PATHS.ONTOLOGY_MANAGER + link}
                                        avatar={validType === "OrderedCollection" ?
                                            <ReorderIcon data-test="ordered-icon" fontSize="small" />
                                            :
                                            validType === "Collection" ?
                                                <GrainIcon data-test="unordered-icon" fontSize="small" />
                                                :
                                                validType === "ConceptScheme" ?
                                                    null
                                                    :
                                                    <OntologyIcon data-test="ontology-icon" fontSize="small" />
                                        } />;
                                })}
                            </TitledPanel>
                        }
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={this.exitInfoDialog}>Close</CancelButton>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

InfoLinkDialog.propTypes = {
    linkList: PropTypes.array.isRequired,
    defaultLang: PropTypes.string.isRequired,
    onToggleView: PropTypes.func,
    validType: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    classes: PropTypes.object
};

export default withRouter(withStyles(styles)(InfoLinkDialog));